import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import { CreateCustomShopForm } from './create-custom-shop-form.tsx';

interface CreateCustomShopDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Modale de création d'une boutique custom. */
export const CreateCustomShopDialog: FC<CreateCustomShopDialogProps> = ({
  isOpen,
  onOpenChange
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl overflow-hidden p-0">
        <div className="scrollable max-h-[90vh] overflow-y-auto p-8 md:p-14">
          <DialogHeader>
            <DialogTitle className="sr-only">{t('admin.shops.create.dialog.title')}</DialogTitle>
            <DialogDescription className="sr-only">
              {t('admin.shops.create.dialog.description')}
            </DialogDescription>
          </DialogHeader>
          <CreateCustomShopForm
            onCancel={() => onOpenChange(false)}
            onSuccess={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
